module.exports = __webpack_public_path__ + "img/2recr_skills.6bb6e41f.png";